import React, { useState } from 'react';
import PortalBranding from './PortalBranding';
import LoginPageBranding from './LoginPageBranding';
import GuestPortalBranding from './GuestPortalBranding';
import { useRemoteUtilityId } from '@shared/selectors/globalSelectors';
import { useGetSelfServieBranding } from '../../hooks';

export const BrandingLanding = () => {
  //useGetSelfServieBranding
  const remoteUtilityId = useRemoteUtilityId();
  const { data: selfServiceBranding, refetch } = useGetSelfServieBranding(remoteUtilityId);

  React.useEffect(() => {
    refetch();
  }, [refetch]);

  const [portalMode, setPortalMode] = useState<'logo' | 'text'>('logo');
  const [portalText, setPortalText] = useState('');
  const [portalLogo, setPortalLogo] = useState<File | null>(null);

  const [loginMode, setLoginMode] = useState<'default' | 'custom'>('default');
  const [loginBgColor, setLoginBgColor] = useState('Ocean Blue');
  const [loginCustomImage, setLoginCustomImage] = useState<File | null>(null);

  const colorMapReverse: any = {
    'ocean_blue': 'Ocean Blue',
    'violet_pink': 'Violet Pink',
    'teal_sky': 'Teal Sky',
    'sunset': 'Sunset',
    'forest': 'Forest',
    'navy_solid': 'Navy Solid'
  };

  const portalData = selfServiceBranding?.result?.find((r: any) => r.brandingType === 1);
  const loginData = selfServiceBranding?.result?.find((r: any) => r.brandingType === 0);

  React.useEffect(() => {
    if (portalData) {
      if (portalData.brandingFieldType === 1) {
        setPortalMode('text');
        setPortalText(portalData.brandText || '');
      } else {
        setPortalMode('logo');
      }
    }
    if (loginData) {
      if (loginData.brandingFieldType === 3) {
        setLoginMode('custom');
      } else {
        setLoginMode('default');
        setLoginBgColor(colorMapReverse[loginData.preset] || 'Ocean Blue');
      }
    }
  }, [portalData, loginData]);

  const isPortalPristine = React.useMemo(() => {
    if (!portalData) return false;
    if (portalData.brandingFieldType === 1) {
      return portalMode === 'text' && portalText === (portalData.brandText || '');
    } else {
      return portalMode === 'logo' && portalLogo === null;
    }
  }, [portalMode, portalText, portalLogo, portalData]);

  const isLoginPristine = React.useMemo(() => {
    if (!loginData) return false;
    if (loginData.brandingFieldType === 3) {
      return loginMode === 'custom' && loginCustomImage === null;
    } else {
      return loginMode === 'default' && loginBgColor === (colorMapReverse[loginData.preset] || 'Ocean Blue');
    }
  }, [loginMode, loginBgColor, loginCustomImage, loginData]);


  const handleResetPortal = () => {
    if (portalData) {
      if (portalData.brandingFieldType === 1) {
        setPortalMode('text');
        setPortalText(portalData.brandText || '');
      } else {
        setPortalMode('logo');
      }
      setPortalLogo(null);
    } else {
      setPortalMode('logo');
      setPortalText('');
      setPortalLogo(null);
    }
  };

  const handleResetLogin = () => {
    if (loginData) {
      if (loginData.brandingFieldType === 3) {
        setLoginMode('custom');
      } else {
        setLoginMode('default');
        setLoginBgColor(colorMapReverse[loginData.preset] || 'Ocean Blue');
      }
      setLoginCustomImage(null);
    } else {
      setLoginMode('default');
      setLoginBgColor('Ocean Blue');
      setLoginCustomImage(null);
    }
  };

  return (
    <div className="space-y-6 pb-12">
      <PortalBranding
        mode={portalMode}
        setMode={setPortalMode}
        text={portalText}
        setText={setPortalText}
        logoFile={portalLogo}
        setLogoFile={setPortalLogo}
        onReset={handleResetPortal}
        remoteUtilityId={remoteUtilityId}
        isPristine={isPortalPristine}
        existingLogoUrl={portalData?.logo}
        existingId={portalData?.id}
      />
      
      <LoginPageBranding
        mode={loginMode}
        setMode={setLoginMode}
        bgColor={loginBgColor}
        setBgColor={setLoginBgColor}
        customImageFile={loginCustomImage}
        setCustomImageFile={setLoginCustomImage}
        portalMode={portalMode}
        portalText={portalText}
        portalLogo={portalLogo}
        onReset={handleResetLogin}
        remoteUtilityId={remoteUtilityId}
        isPristine={isLoginPristine}
        existingBgUrl={loginData?.backgroundImage}
        existingId={loginData?.id}
        portalExistingLogoUrl={portalData?.logo}
      />

      <GuestPortalBranding remoteUtilityId={remoteUtilityId} />
    </div>
  );
};